module.exports = __webpack_public_path__ + "img/SAFo_SocialMedia_PhishingAttacks.3d36a302.svg";